import React from 'react';
import { useTranslation } from 'react-i18next';

//Props
interface PropertyDetailsBadgesProps {
    propertyDetails: any;
}

const PropertyDetailsBadges: React.FC<PropertyDetailsBadgesProps> = ({ propertyDetails }) => {

    const { t } = useTranslation();

    const labelList = [
        { key: 'property.elevator', value: Boolean(propertyDetails?.elevator) },
        { key: 'property.alarm', value: Boolean(propertyDetails?.residential?.alarm) },
        { key: 'property.strongDoor', value: Boolean(propertyDetails?.residential?.strongDoor) },
        { key: 'property.independentEntry', value: Boolean(propertyDetails?.residential?.entryDetails.independentEntry) },
        { key: 'property.lastFloor', value: Boolean(propertyDetails?.residential?.lastFloor) },
        { key: 'property.animalsAllowed', value: Boolean(propertyDetails?.residential?.animalsAllowed) },
        { key: 'property.fireplace', value: Boolean(propertyDetails?.residential?.fireplace) },
        { key: 'property.swimmingPool', value: Boolean(propertyDetails?.residential?.swimmingPool) },
        { key: 'property.airConditioning', value: Boolean(propertyDetails?.residential?.conditionerDetails?.conditioner) },
        { key: 'property.furnished', value: propertyDetails?.residential?.fornitureDetails?.furnitureId == 1 ? true : false },
        { key: 'property.semiFurnished', value: propertyDetails?.residential?.fornitureDetails?.furnitureId == 3 ? true : false },
        { key: 'property.cellar', value: Boolean(propertyDetails?.residential?.cellarDetails?.cellar) },
        { key: 'property.tavern', value: Boolean(propertyDetails?.residential?.tavernDetails?.tavern) },
        { key: 'property.attic', value: Boolean(propertyDetails?.residential?.mansardDetails?.mansard) },
        { key: propertyDetails?.residential?.garretDetails?.practicableGarret ? 'property.practicableGarret' : 'property.garret', value: Boolean(propertyDetails?.residential?.garretDetails?.garret) },
        { key: 'property.prestigeProperty', value: Boolean(propertyDetails?.residential?.prestigeProperty) },
        { key: 'property.suitableForStudents', value: Boolean(propertyDetails?.residential?.studentsAllowed) },
        { key: 'property.autoclave', value: Boolean(propertyDetails?.residential?.autoclave) },
        { key: 'property.waterSoftener', value: Boolean(propertyDetails?.residential?.waterSoftener) },
        { key: 'property.mosquitoNets', value: Boolean(propertyDetails?.residential?.mosquitoNet) },
        { key: 'property.videophone', value: Boolean(propertyDetails?.residential?.videophone) },
        { key: 'property.parking.garage', value: Boolean(propertyDetails?.residential?.garageDetails?.garage1 || propertyDetails?.residential?.garageDetails?.garage2) },
        { key: 'property.garden.privateGarden', value: Boolean(propertyDetails?.residential?.gardenDetails?.privateGarden) },
        { key: 'property.garden.condominiumGarden', value: Boolean(propertyDetails?.residential?.gardenDetails?.condominiumGarden) },
        { key: 'property.courtyard', value: Boolean(propertyDetails?.residential?.gardenDetails?.resede) },
    ]

    if (labelList.every(label => !label.value)) {
        return null;
    }

    return (
        <div className="property-detail-info-badges-wrapper mb-5">

            <h3>{t('property.detailInfoBadges.title')}</h3>

            <ul className="list-unstyled d-flex flex-wrap gap-2 mb-0">

                {labelList.map((label, index) => (
                    label.value && (
                        <li key={index} className="badge badge-primary">
                            {t(label.key)}
                        </li>
                    )
                ))}
            </ul>

        </div>
    )
}

export default PropertyDetailsBadges